import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { Asset } from '@/types';
import exodus from '@/ui/exodus';
import type { Sorting } from '@/ui/flux/fiat-balances/selectors/create-sorted-assets-selector-factory.js';
import createSortedAssetsSelector from '@/ui/flux/fiat-balances/selectors/create-sorted-assets.js';

const SORTING = [
  ['fiatBalance', 'desc'],
  ['enabled', 'desc'],
  ['isBaseAsset', 'desc'],
  ['displayName', 'asc'],
] satisfies Sorting;

// TODO: Remove in favor of @exodus/exchange-ui
const useAvailableToAssets = (
  fromAssetTicker?: string,
  { makeRequest = true } = {},
): { availableToAssets: Asset[]; loading: boolean } => {
  const [loading, setLoading] = useState(true);
  const [availableToAssets, setAvailableToAssets] = useState<Asset[]>([]);

  const sortedAssets = useSelector(createSortedAssetsSelector(SORTING));

  useEffect(() => {
    if (!makeRequest || !fromAssetTicker) {
      setLoading(false);
      return;
    }

    setLoading(true);

    exodus.exchange
      .getSupportedToAssetIds(fromAssetTicker)
      .then((fetchedAssets) => {
        setAvailableToAssets(
          sortedAssets.filter((asset) => fetchedAssets.includes(asset.ticker)),
        );
        setLoading(false);
      });
  }, [fromAssetTicker, makeRequest, sortedAssets]);

  return { availableToAssets, loading };
};

export default useAvailableToAssets;
